module.exports = __webpack_public_path__ + "04fa168f3ead94e0cd88c731ccc22b40.jpg";